<template>
    <div class="grid grid-rows-1 grid-cols-1 gap-4 sm:grid-cols-3 md:grid-cols-4">
        <div v-for="customerChannel in displayableChannels" :key="customerChannel.id"
             :class="disabled ? 'bg-gray-200 cursor-not-allowed' : 'shadow bg-white cursor-pointer hover:bg-gray-50'"
             class="flex bg-white rounded-md block items-center group relative"
             @click="!disabled && addChannel(customerChannel)">
            <div @click.prevent.stop="removeChannel(customerChannel)"
                 class="z-10 cursor-pointer group-hover:opacity-100 opacity-100 xl:opacity-0 absolute -top-2 -right-2 transition-opacity h-4 w-4 bg-red-500 rounded-full flex flex-col justify-center items-center">
                <TrashIcon class="h-3 w-3 text-white"/>
            </div>
            <div class="flex flex-row flex-grow items-center">
                <div @click.prevent.stop="copy(customerChannel.value)"
                     class="h-12 w-12 rounded-full cursor-pointer ml-2 flex flex-col justify-center items-center"
                     :class="customerChannel.slug !== 'phone-number' ? 'border' : 'bg-white'">
                    <ClipboardCopyIcon class="h-6 w-6 text-gray-600"/>
                </div>
                <div class="flex flex-col flex-grow truncate py-2 pl-2 pr-4">
                    <p class="text-sm font-medium" :class="customerChannel.slug === 'phone-number' ? 'text-gray-400' : 'text-reethi-purple'">
                        {{ customerChannel.name }}
                    </p>
                    <p
                        :class="customerChannel.slug === 'phone-number' ? 'text-gray-400' : 'text-gray-500'"
                        class="flex items-center text-sm">
                        {{ customerChannel.value }}
                    </p>
                    <div class="flex flex-row mt-2" v-if="false && customerChannel.slug === 'phone-number'">
                        <div
                            @click.stop="toggleWhatsApp()"
                            :class="whatsAppSelected ? 'fill-[#25D366] border-[#25D366]' : 'fill-gray-400'"
                            class="transition-all duration-300 border rounded-full p-2"><whatsapp /></div>
                        <div
                            @click.stop="toggleViber()"
                            :class="viberSelected ? 'fill-[#59267c] border-[#59267c]' : 'fill-gray-400'"
                            class="transition-all duration-300 mx-4 border rounded-full p-2"><viber /></div>
                        <div
                            @click.stop="toggleTelegram()"
                            :class="telegramSelected ? 'fill-[#0088cc] border-[#0088cc]' : 'fill-gray-400'"
                            class="transition-all duration-300 border rounded-full p-2"><telegram /></div>
                    </div>
                </div>
            </div>
            <div class="mx-2" v-if="customerChannel.is_primary">
                <p
                    :class="customerChannel.slug === 'phone-number' ? 'bg-gray-100 text-gray-800' : 'bg-green-100 text-green-800'"
                    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full">
                    Primary
                </p>
            </div>
        </div>
        <div
            v-if="!disabled"
            @click="newChannelDialogOpen = true"
            class="p-4 cursor-pointer hover:bg-gray-200 bg-gray-100 overflow-hidden rounded-md border border-dashed border-gray-300 text-gray-400 flex flex-row justify-center items-center">
            <PlusIcon class="w-4 h-4 mr-4"/>
            New Channel
        </div>
        <create-channel-dialog v-model:open="newChannelDialogOpen" :channels="channelOptions" :customer="customer" @created="reloadPage()"/>
        <delete-channel-dialog v-model:open="deleteChannelDialogOpen" :channel="selectedChannel" :customer="customer" @deleted="reloadPage()"/>
    </div>
</template>

<script>
import { ref } from "vue";
import {
    PlusIcon,
    TrashIcon,
    ClipboardCopyIcon,
} from "@heroicons/vue/solid";
import Viber from "@/Pages/Orders/Icons/viber";
import { copyToClipboard } from "@/Utils/functions";
import Telegram from "@/Pages/Orders/Icons/telegram";
import Whatsapp from "@/Pages/Orders/Icons/whatsapp";
import CreateChannelDialog from "@/Pages/Customers/components/CreateChannelDialog";
import DeleteChannelDialog from "@/Pages/Customers/components/DeleteChannelDialog";

export default {
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        customer: {
            type: Object,
            required: true
        },
        except: {
            type: Array,
            default: []
        },
        channelOptions: {
            type: Array,
            required: true
        },
    },
    setup(props) {
        const newChannelDialogOpen = ref(false);
        const deleteChannelDialogOpen = ref(false);
        const selectedChannel = ref(props.customer.channels.length ? props.customer.channels[0] : props.customer.channels);

        return {
            selectedChannel,
            newChannelDialogOpen,
            deleteChannelDialogOpen,
        }
    },
    computed: {
        displayableChannels() {
            return this.customer.channels.filter(channel => this.except.filter(ex => {
                if (isNaN(ex)) {
                    return channel.pivot_id === ex.id;
                } else {
                    return channel.pivot_id === ex;
                }
            }).length === 0)
        }
    },
    data() {
        return {
            viberSelected: false,
            whatsAppSelected: false,
            telegramSelected: false,
        }
    },
    components: {
        Viber,
        Whatsapp,
        Telegram,
        PlusIcon,
        TrashIcon,
        ClipboardCopyIcon,

        CreateChannelDialog,
        DeleteChannelDialog,
    },
    emits: ['channelAdded', 'reload'],
    methods: {
        async copy(text) {
            try {
                await copyToClipboard(text)
                this.$page.props.flash = {
                    success: "Copied to clipboard"
                }
            } catch (e) {
                this.$page.props.flash = {
                    error: "Failed to copy to clipboard"
                }
            }
        },
        addChannel(customerChannel) {
            this.$emit('channelAdded', customerChannel)
        },
        removeChannel(channel) {
            this.selectedChannel = channel;
            this.deleteChannelDialogOpen = true;
        },
        reloadPage() {
            this.$emit('reload')
        },
        toggleWhatsApp() {
            this.whatsAppSelected = !this.whatsAppSelected;
        },
        toggleViber() {
            this.viberSelected = !this.viberSelected;
        },
        toggleTelegram() {
            this.telegramSelected = !this.telegramSelected;
        },
    }
}
</script>
